import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { ReactComponent as CheckCircle } from 'assets/icons/status/check-circle--16.svg';
import { ReactComponent as EmptyCircle } from 'assets/icons/web-16/empty-circle--16.svg';
import i18n from '../../../i18n';
import { Text, TextTypography } from 'components/Text/Text';
import { makeStyles } from '@material-ui/core/styles';
import { WrappedFieldProps } from 'redux-form';

export interface RoundCheckboxProps {
    value: boolean;
    label: string;
    name: string;
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    // Optional:
    className?: string;
    strikeThroughIfChecked?: boolean;
}

const useStyles = makeStyles({
    label: {
        textDecorationLine: (params: Partial<RoundCheckboxProps>) => {
            return params.value && params.strikeThroughIfChecked ? 'line-through' : 'none';
        },
    },
});

export const RoundCheckbox = (params: RoundCheckboxProps) => {
    const { t } = i18n.useTranslation();
    const classes = useStyles(params);

    return (
        <div className={params.className}>
            <FormControlLabel
                control={
                    <Checkbox
                        icon={<EmptyCircle />}
                        checkedIcon={<CheckCircle />}
                        onChange={params.handleChange}
                        checked={params.value}
                        name={params.name}
                    />
                }
                label={
                    <Text className={classes.label} typography={TextTypography.BODY}>
                        {t(params.label)}
                    </Text>
                }
            />
        </div>
    );
};

export type RoundCheckboxControlFieldProps = RoundCheckboxProps & WrappedFieldProps;

export const RoundCheckboxControlField = (props: RoundCheckboxControlFieldProps) => {
    const {
        input: { onChange, ...input },
        label,
    } = props;
    return <RoundCheckbox label={label} handleChange={onChange} {...input} />;
};
